// Candidate status enum matching backend
export type CandidateStatus = 'DRAFT' | 'PENDING' | 'CONFIRMED' | 'REJECTED';

// Candidate matching backend CandidateResponse DTO
export interface Candidate {
  id: string;
  companyId: string;
  email: string;
  name: string;
  country?: string | null;
  phone?: string | null;
  status: CandidateStatus;
  shareId: string;
  consentGiven: boolean;
  consentDate?: string | null;
  over16?: boolean | null;
  termsAccepted: boolean;
  contactForJobOffers?: boolean | null;
  deleted: boolean;
  createdAt: string;
  updatedAt: string;
}

// Request DTOs matching backend
export interface CreateCandidateRequest {
  email: string;
  name: string;
  country?: string | null;
  phone?: string | null;
}

export interface UpdateCandidateRequest {
  email?: string;
  name?: string;
  country?: string | null;
  phone?: string | null;
}

export interface UpdateCandidateStatusRequest {
  status: CandidateStatus;
}

export interface UpdateCandidateConsentRequest {
  over16: boolean;
  termsAccepted: boolean;
  contactForJobOffers?: boolean | null;
}

// Query parameters for listing candidates.
// Searching, filtering and sorting are done client-side (see useTableFilters).
export interface ListCandidatesParams {
  companyId: string;
}

// Status display configuration
export const CANDIDATE_STATUS_CONFIG: Record<
  CandidateStatus,
  { label: string; color: 'default' | 'warning' | 'success' | 'destructive' }
> = {
  DRAFT: { label: 'Draft', color: 'default' },
  PENDING: { label: 'Pending', color: 'warning' },
  CONFIRMED: { label: 'Confirmed', color: 'success' },
  REJECTED: { label: 'Rejected', color: 'destructive' },
};

// Status transition rules (which transitions are allowed)
export const CANDIDATE_STATUS_TRANSITIONS: Record<CandidateStatus, CandidateStatus[]> = {
  DRAFT: ['PENDING', 'REJECTED'],
  PENDING: ['CONFIRMED', 'REJECTED', 'DRAFT'],
  CONFIRMED: ['REJECTED'],
  REJECTED: ['DRAFT'],
};
